import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators, compose } from 'redux'
import * as userActions from '../../actions/userActions'
import { withRouter } from 'react-router-dom'
import ApiURL from '../../Api/ApiUrl'
import cookie from 'react-cookies'
import { polishMonthsNormal, polishMonthsVariant } from '../../utils/index'
import Notifications, { notify } from 'react-notify-toast'
import axios from 'axios'
import moment from 'moment'
import {
  getUserData,
  patchUserData,
  compressImages,
  generatePhotoAwsUrl,
  addUserFeed,
  setUserTrainingDays,
} from '../../Api/backendApi'

import AddUser from './AddUser'
import UserWizzard from './Red_UserWizzard.tsx'

class AddUserContainer extends Component {
  state = {
    steps: 11,
    activeStep: 0,
    userName: '',
    bellyCircumference: 20,
    hipCircumference: 20,
    thighCircumference: 20,
    userFrontPhoto: [],
    userSidePhoto: [],
    userBackPhoto: [],
    isUserFrontPhotoUploaded: false,
    trenningTime: null,
    trainingDays: [],
    showFrontBackground: true,
    showBackBackground: true,
    showSideBackground: true,
    trainingReminder: false,
    isModalOpen: false,
    isNotificationModalOpen: false,
    userBackend: {},
    userWizzardSecondVideoUrl: null,
    tempUserBackBackground: '',
    tempUserFrontBackground: '',
    tempUserSideBackground: '',
    userBackBackground: '',
    userSideBackground: '',
    userFrontBackground: '',
    isAgreementButtonsOn: false,
    defaultTrenningTime: '12:30',
    isUserLoggedIn: cookie.load('accessToken') ? true : false,
  }

  componentDidMount = async () => {
    let userData = await getUserData()
    this.setState({
      user: userData,
    })

    // if (
    //   !this.state.isUserLoggedIn ||
    //   this.state.user.name != ''
    //   // this.state.user.has_subscription
    // ) {
    //   this.props.history.push('/')
    //   return
    // }

    const video = await this.getSingleVideo()

    await this.setState({
      userWizzardSecondVideoUrl: video,
    })

    this.getSingleVideo()
  }

  getSingleVideo = async () => {
    let singleVideo
    const getSingleVideoConfig = {
      method: 'GET',
      url: `${ApiURL}/api/vimeovideos/videos/${371489741}`,
      headers: {
        Authorization: 'Bearer ' + cookie.load('accessToken'),
      },
    }

    await axios(getSingleVideoConfig)
      .then((response) => {
        singleVideo = response.data
      })
      .catch(({ error, response }) => {
        console.log(error)

        if (error.status == 401) {
          // refreshToken()
          // this.getSingleVideo()
        } else {
          console.log(error)
        }
      })
    return singleVideo
  }

  userData = async () => {
    const result = await getUserData()

    this.setState({
      userBackend: result,
    })
  }

  onInputEdit = (e, input) => {
    switch (input) {
      case 'name':
        this.setState({
          userName: e.target.value,
        })
        break
      case 'bellyCircumference':
        this.setState({
          bellyCircumference: e.target.value,
        })
        break
      case 'hipCircumference':
        this.setState({
          hipCircumference: e.target.value,
        })
        break
      case 'thighCircumference':
        this.setState({
          thighCircumference: e.target.value,
        })
        break
      case 'trenningTime':
        this.setState({
          trenningTime: e.target.value,
        })
        break
      default:
        return
    }
  }

  isDisabled = (day) => {
    return (
      this.state.trainingDays.length > 5 &&
      this.state.trainingDays.includes(day)
    )
  }

  checkTrenningDay = (e, day) => {
    let filtered
    if (!this.state.trainingDays.includes(day)) {
      this.setState({
        trainingDays: [...this.state.trainingDays, day],
      })
    } else {
      filtered = this.state.trainingDays.filter((days) => days !== day)
      this.setState({
        trainingDays: [...filtered],
      })
    }
  }

  onNavButtonClick = (buttonMode) => {
    if (buttonMode == 'next') {
      if (this.state.activeStep == 0 && this.state.userName == '') {
        alert('Podaj imię aby przejść dalej')
        return
      } else if (
        this.state.activeStep == 9 &&
        this.state.trainingDays.length !== 5
      ) {
        alert('Wybierz 5 dni treningowych')
        return
      } else {
        if (this.state.activeStep < 10)
          this.setState({ activeStep: this.state.activeStep + 1 })
      }
    }
    if (buttonMode == 'prev') {
      if (
        (this.state.activeStep > 0 && this.state.activeStep <= 7) ||
        this.state.activeStep == 9
      )
        this.setState({ activeStep: this.state.activeStep - 1 })
    }
  }
  goToLocation = (location) => {
    this.props.history.push(location)
  }
  goToStep = (step) => {
    this.setState({
      activeStep: step,
    })
  }

  onImageSave = (e, side) => {
    this.switchAgreementButtons()

    this.saveTempImages(e.target.files[0], side)
  }

  switchAgreementButtons = () => {
    this.setState({
      isAgreementButtonsOn: !this.state.isAgreementButtonsOn,
    })
  }

  saveTempImages = (fileImage, side) => {
    const getImagePath = URL.createObjectURL(fileImage)

    switch (side) {
      case 'front':
        this.setState({
          tempUserFrontPhoto: fileImage,
          tempUserFrontBackground: getImagePath,
        })
        break
      case 'side':
        this.setState({
          tempUserSidePhoto: fileImage,
          tempUserSideBackground: getImagePath,
        })
        break
      case 'back':
        this.setState({
          tempUserBackPhoto: fileImage,
          tempUserBackBackground: getImagePath,
        })
        break
      default:
        return
    }
  }
  saveOriginalImages = (side) => {
    switch (side) {
      case 'front':
        this.setState({
          userFrontPhoto: this.state.tempUserFrontPhoto,
          userFrontBackground: this.state.tempUserFrontBackground,
        })
        break
      case 'side':
        this.setState({
          userSidePhoto: this.state.tempUserSidePhoto,
          userSideBackground: this.state.tempUserSideBackground,
        })
        break
      case 'back':
        this.setState({
          userBackPhoto: this.state.tempUserBackPhoto,
          userBackBackground: this.state.tempUserBackBackground,
        })
        break
      default:
        return
    }
    this.switchAgreementButtons()
    this.setState({
      activeStep: this.state.activeStep + 1,
    })
  }

  changeDefaultBackground = (side) => {
    switch (side) {
      case 'front':
        this.setState({
          showFrontBackground: false,
        })
        break
      case 'side':
        this.setState({
          showSideBackground: false,
        })
        break
      case 'back':
        this.setState({
          showBackBackground: false,
        })
        break
    }
  }

  resetBackground = (side) => {
    switch (side) {
      case 'front':
        this.setState({
          userFrontPhoto: [],
        })
        break
      case 'side':
        this.setState({
          userSidePhoto: [],
        })
        break
      case 'back':
        this.setState({
          userBackPhoto: [],
        })
        break
      default:
        return
    }
  }

  checkReminder = (e) => {
    this.setState({
      trainingReminder: e.target.checked,
    })
  }

  storeData = async () => {
    let hour
    let minutes

    if (this.state.trenningTime) {
      hour = this.state.trenningTime.split(':')[0]
      minutes = this.state.trenningTime.split(':')[1]
    } else {
      hour = this.state.defaultTrenningTime.split(':')[0]
      minutes = this.state.defaultTrenningTime.split(':')[1]
    }

    const date = new Date()
    const correctDate = moment(date).format('YYYY-MM-DD')
    await addUserFeed(
      this.state.bellyCircumference,
      this.state.hipCircumference,
      this.state.thighCircumference,
      correctDate
    )

    await generatePhotoAwsUrl('F', this.state.userFrontPhoto)
    await generatePhotoAwsUrl('S', this.state.userSidePhoto)
    await generatePhotoAwsUrl('B', this.state.userBackPhoto)
    await setUserTrainingDays(this.state.trainingDays, hour, minutes)

    await patchUserData(this.state.userName, false, true, this.state.user.id)
    this.openModal('notification')

    setTimeout(() => {
      this.goToLocation('/trening')
    }, 1500)
  }

  setTempTime = (time) => {
    this.setState({
      trenningTempTime: time == null ? this.state.defaultTrenningTime : time,
    })
  }
  saveTempTime = () => {
    this.setState({
      trenningTime:
        this.state.trenningTempTime == null ||
        this.state.trenningTempTime == undefined
          ? this.state.defaultTrenningTime
          : this.state.trenningTempTime,
    })
    this.closeModal('time')
  }
  openModal = (modalType) => {
    if (modalType == 'time') {
      this.setState({
        isModalOpen: true,
      })
    } else {
      this.setState({
        isNotificationModalOpen: true,
      })
    }
  }
  closeModal = (modalType) => {
    if (modalType == 'time') {
      this.setState({
        isModalOpen: false,
      })
    } else {
      this.setState({
        isNotificationModalOpen: false,
      })
    }
  }

  validateFileType = (file) => {
    if (
      file.type != 'image/jpeg' &&
      file.type != 'image/png' &&
      file.type !== 'image/webp'
    ) {
      alert('Proszę wybrać poprawny format zdjęcia')
      return false
    }
    return true
  }

  validateFileSize = (file) => {
    if (file.size > 5000000) {
      alert('Zdjęcie musi być mniejsze niż 5 mb')
      return false
    }
    return true
  }

  returnCorrectSideName = (side) => {
    switch (side) {
      case 'side':
        return 'S'
      case 'front':
        return 'F'
      case 'back':
        return 'B'
      default:
        return
    }
  }

  onChangeHandler = (e, side) => {
    if (
      !this.validateFileType(e.target.files[0]) ||
      !this.validateFileSize(e.target.files[0])
    ) {
      return
    }

    compressImages(e.target.files[0])
    this.setState({
      testFile: e.target.files[0],
    })
    generatePhotoAwsUrl(
      this.returnCorrectSideName(side),
      '2020-08-14',
      e.target.files[0]
    )
  }

  render() {
    return (
      // <AddUser
      //   onInputEdit={this.onInputEdit}
      //   userName={this.state.userName}
      //   steps={this.state.steps}
      //   activeStep={this.state.activeStep}
      //   onNavButtonClick={this.onNavButtonClick}
      //   bellyCircumference={this.state.bellyCircumference}
      //   hipCircumference={this.state.hipCircumference}
      //   thighCircumference={this.state.thighCircumference}
      //   checkTrenningDay={this.checkTrenningDay}
      //   nbCheckedCheckboxes={this.state.trainingDays.length}
      //   trainingDays={this.state.trainingDays}
      //   isDisabled={this.isDisabled}
      //   goToLocation={this.goToLocation}
      //   goToStep={this.goToStep}
      //   onImageSave={this.onImageSave}
      //   userFrontImage={this.state.userFrontPhoto}
      //   changeDefaultBackground={this.changeDefaultBackground}
      //   showBackBackground={this.state.showBackBackground}
      //   showSideBackground={this.state.showSideBackground}
      //   showFrontBackground={this.state.showFrontBackground}
      //   userFrontPhoto={this.state.userFrontPhoto}
      //   userBackPhoto={this.state.userBackPhoto}
      //   userSidePhoto={this.state.userSidePhoto}
      //   resetBackground={this.resetBackground}
      //   checkReminder={this.checkReminder}
      //   storeData={this.storeData}
      //   setTempTime={this.setTempTime}
      //   saveTempTime={this.saveTempTime}
      //   isModalOpen={this.state.isModalOpen}
      //   closeModal={this.closeModal}
      //   openModal={this.openModal}
      //   trenningTime={this.state.trenningTime}
      //   isNotificationModalOpen={this.state.isNotificationModalOpen}
      //   onChangeHandler={this.onChangeHandler}
      //   secondVideo={this.state.userWizzardSecondVideoUrl}
      //   addUserFeed={addUserFeed}
      //   userBackBackground={this.state.tempUserBackBackground}
      //   userFrontBackground={this.state.tempUserFrontBackground}
      //   userSideBackground={this.state.tempUserSideBackground}
      //   isAgreementButtonsOn={this.state.isAgreementButtonsOn}
      //   saveOriginalImages={this.saveOriginalImages}
      //   defaultTrenningTime={this.defaultTrenningTime}
      // />
      <UserWizzard />
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    userActions: bindActionCreators(userActions, dispatch),
  }
}

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(AddUserContainer)
